/**
 * Lightweight gTwin list fetch for Structure Studio transfer UI (WP-C).
 */

export interface GtwinListEntry {
  id: string;
  label: string;
}

function apiBase(): string {
  const fromEnv =
    typeof import.meta !== 'undefined' ? import.meta.env?.VITE_GTWIN_API_URL : undefined;
  if (fromEnv && String(fromEnv).trim()) return String(fromEnv).replace(/\/+$/, '');
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}/gtwin-api`;
  }
  return 'http://127.0.0.1:5173/gtwin-api';
}

function tenantId(): string {
  const raw =
    typeof import.meta !== 'undefined' ? import.meta.env?.VITE_DEFAULT_TENANT : undefined;
  return raw && String(raw).trim() ? String(raw) : 'dev-tenant';
}

export async function fetchGtwinList(limit = 100): Promise<GtwinListEntry[]> {
  const url = `${apiBase()}/api/v1/gtwins?domain=geospatial&limit=${limit}`;
  const r = await fetch(url, {
    headers: { 'X-Tenant-Id': tenantId(), Accept: 'application/json' },
  });
  if (!r.ok) {
    throw new Error(`Failed to list gTwins: ${r.status}`);
  }
  const data = (await r.json()) as {
    features?: Array<{
      id?: string;
      properties?: { envelope?: { id?: string; label?: string } };
    }>;
  };
  const out: GtwinListEntry[] = [];
  for (const f of data.features ?? []) {
    const env = f.properties?.envelope;
    const id = env?.id ?? f.id;
    if (!id) continue;
    out.push({ id, label: env?.label ?? id });
  }
  return out;
}
